module.exports = __webpack_public_path__ + "img/6.60814ebf.png";